<template>
  <div>
    <v-snackbar v-model="errorMessage" :timeout="80000" top color="white">
      <span class="red--text">{{msg}}</span>
      <v-icon @click="errorMessage = false" color="red">mdi-close</v-icon>
    </v-snackbar>
    <!-- Just an image -->
    <div class="container">
      <nav class="navbar navbar-expand-lg navbar-light">
     <img src="/logo.png" width="60" height="40" class="d-inline-block align-top img-f" alt="logo" loading="lazy">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ml-auto py-4 py-md-0">
            <li class="nav-item px-lg-2 text-color">
              <router-link to="/" class="nav-link" href="#">
              <span class="d-inline-block d-sm-block d-md-none icon-width mr-2"><i class="fas fa-home"></i></span>Home</router-link>
            </li>
            
            <li class="nav-item px-lg-2">
              <router-link to="/register" class="nav-link">
              <span class="d-inline-block d-sm-block d-md-none icon-width mr-2"><i class="fas fa-user-plus"></i></span>Register</router-link>
            </li>
          </ul>
        </div>
      </nav>

      <!-- =================Login panel====================================== -->
      <div class="row">

        <!-- first column -->
        <div class="col-sm-12 col-lg-4 d-none d-md-block mt-5 mb-12">
          <img src="/pics1.svg" alt="login" class="img-fluid mt-5"  />
        </div>
        <div class="col-sm-12 col-lg-2 d-none d-md-block mt-5 mb-12">
        </div>

        <!-- second column -->
        <div class="col-sm-12 col-lg-6">
          
          <div style="margin-top: 50px;" class="text-center">
          </div>

          <div class="text-center">
            <h6 style="font-size: 25px;" class="mt-4">Welcome to Greenfarms!</h6>
          </div>

          <form style="width: 80%; margin: auto;" class="mt-7">

              <div class="form-group mt-4">
                <label for="email">Email address</label>
                <input type="email" class="form-control input-style" id="email" required
                 v-bind:class="{'form-control' : true, 'is-invalid' : !validEmail(email) && emailBlured}"
                 v-on:blur="emailBlured = true"
                 v-model='email'>
                  <div class="invalid-feedback">A valid email is required</div>
              </div>

              <div class="form-group">
                <label for="password">Password</label>
                <div class="input-group mb-2" id="show_hide_password">
                    <input :type="show1 ? 'text' : 'password'" class="form-control input-style" id="password" v-model="password">
                    <div class="input-group-prepend">
                        <div class="input-group-text pa-0">
                            <v-btn icon>
                              <i class="fa fa-eye-slash" aria-hidden="true" @click="show1 = !show1" v-if="!show1"></i>
                              <i class="fa fa-eye" aria-hidden="true" @click="show1 = !show1" v-if="show1"></i>
                            </v-btn>
                        </div>
                      </div>
                  </div>
            </div>
            
            <button type="submit" :disabled="isDisabled" class="btn mt-2" style="width: 100%; background-color:#48c074; color:white" id="signIn" @click="login($event)" >Sign In <span class="fa fa-circle-o-notch fa-spin" v-if="loading"></span></button>
            

            <div class="text-right" style="margin-top: 10px;">
              <router-link to="/forgotpassword" style="text-decoration: none; color:#48c074" >Forgot password?</router-link>
            </div>
            <div class="text-center">
              OR
            </div>
            <button type="submit"  class="btn mt-2" style="width: 100%; background-color:#4285F4; color:white"  @click="googlelogin($event)" >Sign In With Google <span class="fa fa-circle-o-notch fa-spin" v-if="loading2"></span></button>
          </form>


          <div class="text-center" style="margin-top: 30px;">
            <p>Don't have an account? <router-link to="/register" style="text-decoration: none;color:#48c074">Click here to register</router-link></p> 
          </div>

        </div>

        
      </div>
    </div>
        
    

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data(){
    return{
      show1:false,
      email:'',
      emailBlured: false,
      password:'',
      valid: false,
      loading: false,
      loading2: false,
      msg:'',
      errorMessage:false
    }
  },
  methods:{
     validate: function(){
      this.emailBlured = true;
      if(this.validEmail(this.email)){
        this.valid = true
      }
    },
    validEmail: function(email){
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      return re.test(email.toLowerCase())
    },
    login(event){
      event.preventDefault()
      this.validate();
       if(this.valid){
         this.loading = true
         this.$store.dispatch("Login", {
            "email": this.email,
            "password": this.password
          })
        .then((success)=>{
          if(success.data.isAdmin===true){
            this.$router.push('/dashboard/admin')
          }else{
            this.$router.push('/dashboard')
          }
          
        })
        .catch((error)=>{
          this.msg= error.response.data.message.toUpperCase()
          this.errorMessage =true
          this.loading = false
        })
       }
      
    },
    async googllogin(event){
      this.loading2=true
      event.preventDefault()
        Vue.googleAuth().directAccess()
        
        await Vue.googleAuth().signIn(function (googleuser) {
          const user1 = googleuser.Ot
          const user = {}
          user.firstname = user1.sW
          user.lastname = user1.sU
          user.email = user1.yu
          user.profileImg = user1.PK
          this.loading2=false
          // things to do when sign-in succeeds
        }, function () {
          this.loading2=false
          // things to do when sign-in fails
        })
        // console.log(u)
        // this.$store.dispatch("LoginGoogle")
        //   .then(()=>{
        //     alert('successful')
            
        //   })
        //   .catch(()=>{
        //     alert('failed')
        //   })
      // await Vue.googleAuth().signIn(this.onSignInSuccess, this.onSignInError)
      // this.validate();
      //  if(this.valid){
      //    this.loading = true
      //    this.$store.dispatch("LoginGoogle")
      //   .then(()=>{
      //     alert('successful')
          
      //   })
      //   .catch(()=>{
      //     alert('failed')
      //   })
      //  }
    },
    googlelogin: function (event) {
      this.loading2=true
      event.preventDefault()
      let ctx = this;
      Vue.googleAuth().directAccess()
      Vue.googleAuth().signIn(function (googleUser) {
        const user1 = googleUser.rt
          let firstname = user1.tV
          let lastname = user1.uT
          let email = user1.$t  
          let profileImg = user1.TJ
          ctx.$store.dispatch('LoginGoogle', {
            'firstname':firstname,
            'lastname':lastname,
            'email':email,
            'profileUrl':profileImg
          })
          .then(()=>{
            ctx.$router.push('/dashboard')
            ctx.loading2=false
          })
          .catch((error)=>{
            console.log(error)
            ctx.msg= error.response.data.message
            ctx.errorMessage =true
            ctx.loading2=false
          })
        // ctx.$router.replace(ctx.$route.query.redirect || '/authors')
      }, function () {
        ctx.loading2=false
      })
      
    },
    authgoogle(event){
      event.preventDefault()
      this.$store.dispatch("GoogleLogin")
      .then(()=>{
        
      })
      .catch(()=>{
      })
       
    }
  },
  computed:{
     isDisabled: function(){
      return this.email.length == "" || this.password.length == "";
    }
  }
}
</script>

<style scoped>
.v-application ul{
  padding: 0px;
}
/* navigation styles */
.nav-item:after{
	position: absolute;
	bottom: -5px;
	left: 40px;
    width: 5px;
    border-radius: 50%;
	height: 5px;
    content: '';
	background-color: #48c074;
	opacity: 0;
    transition: all 200ms linear;
}
.nav-item:hover:after{
	bottom: 0;
	opacity: 1;
}
.nav-item.active:hover:after{
	opacity: 0;
}
.nav-item{
	position: relative;
    transition: all 200ms linear;
}

.navbar-toggler {
	float: right;
	border: none;
	padding-right: 0;
}
.navbar-toggler:active,
.navbar-toggler:focus {
	outline: none;
}
.navbar-light .navbar-toggler-icon {
	width: 24px;
	height: 17px;
	background-image: none;
	position: relative;
	border-bottom: 1px solid #777;
    transition: all 300ms linear;
}
.navbar-light .navbar-toggler-icon:after, 
.navbar-light .navbar-toggler-icon:before{
	width: 24px;
	position: absolute;
	height: 1px;
	background-color: #777;
	top: 0;
	left: 0;
	content: '';
	z-index: 2;
    transition: all 300ms linear;
}
.navbar-light .navbar-toggler-icon:after{
	top: 8px;
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:after {
	transform: rotate(45deg);
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:before {
	transform: translateY(8px) rotate(-45deg);
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
	border-color: transparent;
}
 .input-style{
    padding: 20px 20px;
  }
  .input-style:focus{
    border-color: rgba(50, 54, 67, 0.2);
    box-shadow: 0px 5px 30px rgba(50, 54, 67, 0.2);
    outline: 0 none;
}

@media screen and (max-width: 768px) {
   .nav-item:after{
    visibility: hidden
  }
}
.g{
  color:rgb(0, 204, 255);
}
</style>